import { WishlistEffects } from './wishlist.effect';

export const effects: any[] = [WishlistEffects];
